<h2 mat-dialog-title class="text-lg font-bold mb-1">  {{ isEditMode ? 'Editar Registro' : 'Nuevo Registro' }}</h2>
<mat-dialog-content class="modal-content">
  <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
          <!-- ng-select for socios -->
          <mat-form-field appearance="fill" class="col-span-2">
            <mat-label>Socio de Negocio</mat-label>
            <mat-select
              [(ngModel)]="currentCreateInterlocutor.businessPartnerId"
              (selectionChange)="onBusinessPartnerChange($event.value)"
              placeholder="Seleccione un socio"
              name="businessPartnerId"
              required
            >
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="businessPartnerFilterCtrl"
                  [searching]="isSearchingBusinessPartner"
                  [noEntriesFoundLabel]="'No se encontraron resultados'"
                  [placeholderLabel]="'Buscar por código o nombre...'"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let businessPartner of businessPartnerList"
                [value]="businessPartner._id.toString()"
              >
                <div class="text-sm uppercase leading-tight">
                  <div>
                    <b *ngIf="getCode(businessPartner) as code">{{ code }}</b>
                  </div>
                  {{ businessPartner.name }}
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>

     <!-- ng-select for funciones -->
     <!-- <div class="col-span-2">
        <label for="group-select">Funciones</label>
        <ng-select
          [(ngModel)]="currentCreateInterlocutor.businessPartnerFunctionIds"
          [items]="businessPartnerFunctionList"
          bindLabel="name"
          bindValue="_id"
          [searchable]="true"
          [multiple]="true"
          placeholder="Seleccione funciones"
          name="businessPartnerFunctionIds"
          [appendTo]="'body'"
          required
        >
        </ng-select>
      </div> -->
      <mat-form-field appearance="fill" class="col-span-2">
        <mat-label for="group-select">Funciones</mat-label>
        <mat-select
          [formControl]="functionMultiCtrl"
          placeholder="Seleccione funciones"
          [multiple]="true"
        >
          <mat-option>
            <ngx-mat-select-search
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxIndeterminate]="isIndeterminate"
              [toggleAllCheckboxChecked]="isChecked"
              (toggleAll)="toggleSelectAll($event)"
              [formControl]="functionMultiFilterCtrl"
              [noEntriesFoundLabel]="'No se encontraron resultados'"
              [placeholderLabel]="'Buscar funciones de socio...'"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let function of filteredFunction | async"
            [value]="function"
          >  <b *ngIf="getCode(function) as code ">{{code}} - </b> {{ function.name }}
          </mat-option>
        </mat-select>
        <mat-error
        *ngIf="
          functionMultiCtrl.hasError('required') &&
          (functionMultiCtrl.dirty || functionMultiCtrl.touched)
        "
      >
      Seleccione funciones de socio
      </mat-error>
      </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!createForm.valid"
    class="justify-end"
  >
  {{ isEditMode ? 'Actualizar' : 'Guardar' }}
  </button>
</mat-dialog-actions>
